import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vSelect from 'vue-select';
import Vuelidate from 'vuelidate';
import * as VueGoogleMaps from 'vue2-google-maps';
import BootstrapVue from 'bootstrap-vue';
import './assets/scss/index.scss';
import moment from 'moment';
import './boot/permission'
import bootDefaultData from './boot/default'
import VueClipboard from 'vue-clipboard2';
import i18n from './i18n'
import VueMask from 'v-mask';
import Notifications from 'vue-notification';
import velocity      from 'velocity-animate'
import 'material-design-icons-iconfont'
import InputFacade from 'vue-input-facade';

Vue.config.productionTip = false
moment.locale('ua');

Vue.use(Vuelidate);
Vue.use(VueClipboard);
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCSBPW4XM_TVAxk0ThPIAsw7g4Xjnukp8M',
    },
});
Vue.use(BootstrapVue);
Vue.use(VueMask)
Vue.use(Notifications, { velocity })
Vue.component('v-select', vSelect);
Vue.use(InputFacade);

new Vue({
    router,
    store,
    created() {
        bootDefaultData()
    },

    i18n,
    render: h => h(App)
}).$mount('#app')
